import React, { memo } from 'react';
import { EmailIcon } from '../Icons/EmailIcon';
import { MessageIcon } from '../Icons/MessageIcon';
import type { CommunicationMode } from '../../containers/CommentList/CommentList.types';
import type { IconOverrides } from '../../types/IconOverrides';

interface CommunicationIconProps {
  communicationMode?: CommunicationMode;
  iconOverrides?: IconOverrides;
  className?: string;
}

const CommunicationIconComponent: React.FC<CommunicationIconProps> = ({
  communicationMode,
  iconOverrides,
  className = 'comment-text__communication-icon'
}) => {
  if (communicationMode === 'EMAIL') {
    const emailIconProps = {
      className,
      style: iconOverrides?.emailIconStyles
    };
    return <>{iconOverrides?.emailIcon || <EmailIcon {...emailIconProps} />}</>;
  }

  if (communicationMode === 'SLACK') {
    const messageIconProps = {
      className,
      style: iconOverrides?.messageIconStyles
    };
    return <>{iconOverrides?.messageIcon || <MessageIcon {...messageIconProps} />}</>;
  }

  return null;
};

export const CommunicationIcon = memo(CommunicationIconComponent);
